/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.24",
    versionName: "0.6.0-nightly.2026.8.24",
    versionChannel: "nightly",
    buildDate: "2026-08-24T00:10:13.307Z",
    commitHash: "56591f77e4145c18e31846dc8e1713d3d6ab858b",
};
